import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=a1726c56&scoped=true&"
import script from "./exercise.js?vue&type=script&lang=js&"
export * from "./exercise.js?vue&type=script&lang=js&"
import style0 from "./exercise.vue?vue&type=style&index=0&id=a1726c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1726c56",
  null
  
)

export default component.exports